import { contextFactory } from '@frontend/design-system';
import type { SettingsPanelConfig } from './SETTINGS-PANEL-CONFIG';

interface SettingsPanelContextValue {
  id: SettingsPanelConfig;
  mountTargetId: string;
}

export const [SettingsPanelContext, useSettingsPanelContext] = contextFactory<SettingsPanelContextValue>(
  'useSettingsPanelContext should be used within a SettingsPanelProvider'
);
